// extracted by mini-css-extract-plugin
module.exports = {"tooltipArrow":"_0f7f104","row":"_8019a2e","text":"_4f30f32","tickIcon":"_1c9d929"};